<template>
	<div>
		<div class="box" @click="doClick" :class="{'selected':selected}">
			<div style="position:relative">
				<div class="badge-wrapper">
					<Badge v-if="badge" :value="badge" severity="danger" /><!-- style="border-radius:12px;min-width:18px;font-weight:400;" /> -->
					<Badge v-if="badgeNummeric" :value="badgeNummeric" severity="danger" /><!-- style="border-radius:12px;min-width:18px;font-weight:400;" /> -->
					<Badge v-if="recording" value="Rec" severity="danger" /><!-- style="border-radius:12px;min-width:18px;font-weight:400;" /> -->
				</div>
			</div>
			<GlyphIcon :icon="icon" :color="iconColor" size="30" />
			<div class="label">{{ label }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import GlyphIcon from '@/components/GlyphIcon.vue'
import type { GlyphIconName } from '@/stores/GlyphIcons.types'
import Badge from 'primevue/badge'
import { ref, watch } from 'vue'

interface Props {
	icon: GlyphIconName
	label: string
	click: (id: string) => void
	selected: boolean
	id: string
	badge?: string
	badgeNummeric?: number
	recording?: boolean
}

const props = defineProps<Props>()

const iconColor = ref('')

function doClick() {
	props.click(props.id)
}

watch(() => props.selected, (newValue: boolean) => {
	iconColor.value = newValue ? 'var(--topbar-button-color-selected)' : 'var(--topbar-button-color)'
})

iconColor.value = props.selected ? 'var(--topbar-button-color-selected)' : 'var(--topbar-button-color)'
</script>

<style scoped>
	.box {
		-webkit-app-region: no-drag;
		margin-left: auto;
		margin-right: auto;
		width: 100px;
		border-radius: 5px;
		padding: 5px 0px 5px 0px;
		margin-top: 2px;
		margin-bottom: 2px;
		color: var(--topbar-button-color);
		transition: 0.2s;
	}

	.box:hover {
		cursor: pointer;
		background: var(--p-surface-100);
		border: 1px solid var(--p-surface-300);
	}

	.box:active {
		cursor: pointer;
	}

	.box DIV {
		margin: 0 auto;

	}

	.box.selected {
		color: var(--topbar-button-color-selected);
		background: var(--topbar-button-background-selected);
		border: 1px solid var(--topbar-button-border-selected);
	}

	.label {
		margin-top: -3px !important;
		font-size: 12px;
		font-weight: 400;
		padding-left: 5px;
		padding-right: 5px;
		text-align: center;
		white-space: nowrap;
		letter-spacing: 0.05em;
	}

	@media(prefers-color-scheme: dark) {
		.box:hover {
			background: var(--p-surface-700);
			border: 1px solid var(--p-surface-800);
		}

		.box.selected {
			color: var(--p-text-color);
			background: var(--p-surface-700);
			border: 1px solid var(--p-surface-900);
		}
	}

	.badge-wrapper {
		position: absolute;
		width: 95px;
		text-align: right;
		top: -4px;
		right: 20px;
	}

	@media (min-width:390px) and (max-width:1150px) {
		.label {
			display: none;
		}

		.box {
			width: 50px;
			height: 50px;
			padding-top: 10px;
		}

		.box.selected {
			padding-top: 10px;
		}

		.badge-wrapper {
		width: 45px;
		top: -10px;
		right: 2px;
	}
}
</style>
